import { render, staticRenderFns } from "./Statements.vue?vue&type=template&id=18fcff00&scoped=true&"
import script from "./Statements.vue?vue&type=script&lang=ts&"
export * from "./Statements.vue?vue&type=script&lang=ts&"
import style0 from "./Statements.vue?vue&type=style&index=0&id=18fcff00&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18fcff00",
  null
  
)

export default component.exports